import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 23,
  steps: [
    addColumns({
      table: 'chats',
      columns: [{ name: 'use_assistant', type: 'boolean' }]
    })
  ]
}
